const drawRectangle = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path xmlns="http://www.w3.org/2000/svg" d="M14.5 1.5h-13v13h13zM0 0v16h16V0z" clip-rule="evenodd"/></svg>',
};

export { drawRectangle as default };
